import React from 'react'
import PropTypes from 'prop-types'

// core components
import GridItem from '../../../components/Grid/GridItem.js'
import SummaryFigures from '../SummaryFigures.js'
import Card from '../../../components/Card/Card.js'

import SiteView from './SiteView.js'

const formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2
})

export default function OrganisationView ({ orgSummary, mockPriceChanges }) {
  React.useEffect(() => {
  }, [])

  const listViewComponent = () => {
    return <> <GridItem xs={12} style={{ marginBottom: '15px', marginTop: '0px', textAlign: 'center' }}>
      <Card color="danger" style={{ marginTop: 0, marginBottom: 0, height: '100%' }}>
        <h4><b>Today&apos;s Sales</b></h4>
      </Card>
    </GridItem>
    <GridItem xs={12} style={{ marginBottom: '15px' }}>
      <SummaryFigures
        noSales={orgSummary.noSales}
        cancelled={orgSummary.cancelled}
        voids={orgSummary.voids}
        discounts={formatter.format(orgSummary.discounts / 100)}/>
    </GridItem>
    {orgSummary.sites.map(site => (
      <SiteView
        key={site.id}
        site={site}
        mockPriceChanges={mockPriceChanges}
      />
    )) } </>
  }

  return listViewComponent()
}

OrganisationView.propTypes = {
  siteList: PropTypes.any,
  mockPriceChanges: PropTypes.any
}
